import React, {
    useState, useEffect
} from 'react';
import {
    Input
} from 'shared/components/ui/input';

/**
 * NumberInput — thin wrapper over <Input type="number"> with min/max validation
 * and helper text. Per A-0012.02 SPEC §2.2.
 */
export default function NumberInput({
    value,
    onChange,
    min,
    max,
    step,
    placeholder,
    helperText,
    className = '',
    disabled = false
}) {
    const [localError, setLocalError] = useState('');

    useEffect(() => {
        if (value === '' || value === null || value === undefined) {
            setLocalError('');
            return;
        }
        const n = Number(value);
        if (Number.isNaN(n)) {
            setLocalError('Must be a number');
        } else if (typeof min === 'number' && n < min) {
            setLocalError(`Min ${min}`);
        } else if (typeof max === 'number' && n > max) {
            setLocalError(`Max ${max}`);
        } else {
            setLocalError('');
        }
    }, [value, min, max]);

    return (
        <div className={className}>
            <Input
                type="number"
                value={value ?? ''}
                onChange={(e) => onChange?.(e.target.value === '' ? '' : Number(e.target.value))}
                min={min}
                max={max}
                step={step}
                placeholder={placeholder}
                disabled={disabled}
            />
            {(localError || helperText) && (
                <div className={`mt-1 text-xs ${localError ? 'text-red-600' : 'text-muted-foreground'}`}>
                    {localError || helperText}
                </div>
            )}
        </div>
    );
}
